import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@sentinel/ui';

export interface WebAuthnChallengeStepProps {
  onStart: () => void;
  status: 'idle' | 'pending' | 'success' | 'error';
  error?: string | null;
  supported: boolean;
}

export function WebAuthnChallengeStep({
  onStart,
  status,
  error,
  supported,
}: WebAuthnChallengeStepProps) {
  const { t } = useTranslation('mfa');

  return (
    <div
      role="tabpanel"
      id="mfa-challenge-panel-webauthn"
      aria-labelledby="mfa-challenge-tab-webauthn"
      style={{ display: 'grid', gap: '1rem' }}
    >
      {!supported ? (
        <Alert type="warning" role="alert">
          {t('webauthn_unsupported')}
        </Alert>
      ) : (
        <>
          <p>{t('webauthn_intro')}</p>

          {error ? (
            <Alert type="error" role="alert">
              {error}
            </Alert>
          ) : null}

          {status === 'success' ? (
            <Alert type="success" role="status">
              {t('verify_success')}
            </Alert>
          ) : null}

          <Button
            type="button"
            data-testid="mfa-verify-webauthn-start"
            onClick={onStart}
            disabled={status === 'pending'}
          >
            {status === 'pending' ? t('webauthn_in_progress') : t('webauthn_start')}
          </Button>
        </>
      )}
    </div>
  );
}
